/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarAvailability } from './calendarAvailability';
import { AppointmentBlocker } from './appointmentBlocker';
import { AppointmentSerializerDetail } from './appointmentSerializerDetail';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarResponse { 
    appointments: Array<AppointmentSerializerDetail>;
    blockers: Array<AppointmentBlocker>;
    availabilities: Array<CalendarAvailability>;
}
export const CalendarResponse_appointments_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarResponse_blockers_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarResponse_availabilities_Validators: ValidatorFn[] =
    [  Validators.required, ];


